<template>
    <div v-if="course" class="courses-single-page">
        <div class="container">
            <div class="row">
                <div class="col-lg-8 col-12">
                    <div class="content-page-wrap clearfix">
                        <div class="course-single">
                            <div class="featured-post">
                                <div class="entry-image">
                                    <a class="fancybox">
                                        <i class="fa fa-5x fa-image" v-if="!course.imageFileName" style="margin-left: 35%; margin-top: 10%;"></i>
                                        <img v-else v-bind:src="course | s3url" alt="images" style="margin-top: 30px;">
                                    </a>
                                </div>
                            </div>
                            <div class="content">
                                <div class="title">
                                    <a href="#" class="accent-secondary-tx">{{ course.name }}</a>
                                </div>
                                <p>
                                    {{ course.descriptionShort }}
                                </p>
                                <div class="author-price">
                                    <div class="author">
                                        <div class="avatar">
                                            <img v-if="course.author && course.author.imageFileName" v-bind:src="course.author | s3url" alt="images" style="max-width: 80px">
                                            <i class="fa fa-5x fa-image" v-else style=""></i>
                                        </div>
                                        <div class="info">
                                            <div class="name">
                                                <a v-if="course.author" href="#">{{ course.author.firstName }} {{ course.author.lastName }}</a>
                                            </div>
                                            <div v-if="course.author" class="job">
                                                {{ course.author.jobTitle }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="price-wrap price-course-single">
                                        <div class="d-flex align-items-center">
                                            <div class="price">
                                                <span class="price-now">{{ course.price ? "R" + course.price : "" }}<span v-show="course.price" class="font-smaller"> Excl. VAT</span></span>
                                            </div>
                                            <div class="btn-buynow">
                                                <router-link class="btn-site-primary" v-if="course.userAssigned" :to="{ name: 'CourseDetails', params: { id: course.id }}">Continue</router-link>
                                                <a v-else class="btn-site-primary text-nowrap" v-on:click="addToCart">{{ course.price > 0 ? "Add to cart" : "Enrol" }}</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="flat-tabs">
                            <ul class="tab-title type1 clearfix">
                                <li class="item-title accent-primary-bg accent-primary-tx" v-on:click="selectedTab = 0" v-bind:class="{ active: (selectedTab == 0) }">
                                    <span class="inner">OVERVIEW</span>
                                </li>
                                <li class="item-title accent-primary-bg accent-primary-tx" v-on:click="selectedTab = 1" v-bind:class="{ active: (selectedTab == 1) }">
                                    <span class="inner">INSTRUCTOR</span>
                                </li>
                            </ul>
                            <div class="tab-content-wrap">
                                <div class="tab-content" v-show="selectedTab == 0">
                                    <div class="item-content">
                                        <div v-html="course.descriptionLong" v-if="course.descriptionLong"></div>
                                        <div class="title text-center" v-else>
                                            No description
                                        </div>
                                    </div>
                                </div>
                                <div v-if="course.author" class="tab-content" v-show="selectedTab == 1">
                                    <div class="item-content">
                                        <div class="question-sg text clearfix">
                                            <h1>
                                                {{ course.author.firstName }} {{ course.author.lastName }}
                                            </h1>
                                            <h2 v-if="course.author.jobTitle">{{ course.author.jobTitle }}</h2>
                                            <div class="plyr-video" v-if="course.author.videoFileName">
                                                <vue-plyr>
                                                    <video v-bind:src="course.author | s3url('video')">
                                                    </video>
                                                </vue-plyr>
                                            </div>
                                            <p style="margin-top: 10px" v-html="course.author.bio" v-if="course.author.bio">
                                                {{ course.author.bio }}
                                            </p>
                                            <p v-else>No bio</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-12">
                    <div class="sidebar-right">
                        <!--create in lms and populate here-->
                        <div class="widget widget-features accent-primary-bs accent-primary-bd" style="margin-top: 40px;" v-if="course.details.courseFeatures && course.details.courseFeatures.length > 0">
                            <div class="widget-title">
                                Course Features
                            </div>
                            <div class="content">
                                <ul class="features accent-secondary-tx">
                                    <li v-for="feature in course.details.courseFeatures" class="d-flex justify-content-between">
                                        <div>
                                            <i v-if="feature.featureIcon" class="mr-2" v-bind:class="feature.featureIcon"></i>
                                            <span class="info-label">{{feature.featureName}}</span>
                                        </div>
                                        <span class="info-value">{{feature.featureValue}}</span>
                                    </li>
                                    <li>
                                        <i class="fa fa-book mr-2"></i>
                                        <span class="info-label">Category</span>
                                        <span class="info-value">
                                            {{course.category}}
                                        </span>
                                    </li>
                                </ul>
                                <!--
                                <div class="share-via">
                                    <div class="title">
                                        Share via
                                    </div>
                                    <ul class="social-media">
                                        <li><a href="#"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
                                        <li><a href="#"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
                                        <li><a href="#"><i class="fa fa-instagram" aria-hidden="true"></i></a></li>
                                        <li><a href="#"><i class="fa fa-google-plus" aria-hidden="true"></i></a></li>
                                    </ul>
                                </div>
                                    -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
    .font-smaller{
        font-size: 12px;
        white-space: nowrap;
    }

    .plyr-video {
        margin: 20px auto 20px auto;
        max-width: 80%;
    }

    .item-content h1 {
        font-size: 24px;
        line-height: 30px;
        font-weight: 500;
        color: #004A8D;
        margin-bottom: 15px;
    }

    .item-content p {
        font-size: 17px;
        color: #7a7a7a;
        font-weight: 400;
        margin-bottom: 15px;
        text-align: justify;
    }

    .item-content ul {
        margin-bottom: 15px;
    }

    .item-content li:before {
        content: '\f00c';
        font-family: "FontAwesome";
        color: #fbb545;
        position: absolute;
        left: 0;
    }

    .item-content li {
        margin-bottom: 5px;
        font-size: 17px;
        position: relative;
        display: block;
        padding-left: 34px;
    }
</style>

<script>

    export default {
        name: 'CourseInfo',
        components: {

        },
        props: {

        },
        data() {
            return {
                course: null,
                selectedTab: 0
            }
        },
        computed: {
            courseId() {
                // We will see what `params` is shortly
                return this.$route.params.id
            },
            siteDesign() {
                return this.$store.state.siteDesign;
            }
        },
        methods: {
            addToCart() {
                this.$store.commit("addToCart", {
                    type: "course",
                    id: this.course.id,
                    name: this.course.name,
                    price: this.course.price,
                    priceUsd: this.course.priceUsd,
                    imageFileName: this.course.imageFileName
                });
            }
        },
        async mounted() {

            debugger;
            this.course = await this.web("/courses/info/" + this.courseId);

            var crumbs = {};
            crumbs["/courses"] = "Courses";
            crumbs["/courses/" + this.courseId] = this.course.name;
            this.$store.commit("breadCrumbs", crumbs);
        }
    }

</script>
